import { monitoringStatusLabel } from '@/lib/monitoring-panel'
import type { AdminMonitoringHistoryItem } from '@/types/api'
import styles from './MonitoramentoPage.module.css'

interface MonitoringHistoryProps {
  history: AdminMonitoringHistoryItem[]
}

function tickClass(status: AdminMonitoringHistoryItem['status']): string {
  if (status === 'ok') return styles.historyOk
  if (status === 'degraded') return styles.historyDegraded
  return styles.historyCritical
}

export function MonitoringHistory({ history }: MonitoringHistoryProps) {
  if (history.length === 0) return null

  const chronological = [...history].reverse()

  return (
    <section className={styles.section} aria-label="Histórico de funcionamento">
      <h2 className={styles.sectionTitle}>Histórico</h2>
      <div className={styles.history}>
        {chronological.map((item, index) => (
          <span
            key={`${item.generated_at ?? 'run'}-${index}`}
            className={`${styles.historyTick} ${tickClass(item.status)}`}
            title={`${monitoringStatusLabel(item.status)} · ${item.duration_ms} ms`}
          />
        ))}
      </div>
    </section>
  )
}
